import UUID from 'uuid/v1'
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} [cFormat]
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (time == undefined || time == null) {
        return null
    }
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string') {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (time == undefined) {
        return ''
    }
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        // return (
        //     d.getMonth() +
        //     1 +
        //     '月' +
        //     d.getDate() +
        //     '日' +
        //     d.getHours() +
        //     '时' +
        //     d.getMinutes() +
        //     '分'
        // )
        return parseTime(time, '{m}-{d} {h}:{i}')
    }
}

export function faceConvert(faceText, callback) {
    if (faceText == undefined) {
        return ''
    }
    var emot_text = [
        '[微笑]',
        '[撇嘴]',
        '[色]',
        '[发呆]',
        '[得意]',
        '[流泪]',
        '[害羞]',
        '[闭嘴]',
        '[睡]',
        '[大哭]',
        '[发怒]',
        '[调皮]',
        '[龇牙]',
        '[惊讶]',
        '[快哭了]',
        '[抓狂]',
        '[吐]',
        '[偷笑]',
        '[愉快]',
        '[白眼]',
        '[傲慢]',
        '[饥饿]',
        '[困]',
        '[惊恐]',
        '[流汗]',
        '[憨笑]',
        '[大兵]',
        '[奋斗]',
        '[咒骂]',
        '[疑问]',
        '[嘘]',
        '[晕]',
        '[疯了]',
        '[衰]',
        '[骷髅]',
        '[敲打]',
        '[再见]',
        '[擦汗]',
        '[抠鼻]',
        '[鼓掌]',
        '[糗大了]',
        '[坏笑]',
        '[左哼哼]',
        '[右哼哼]',
        '[哈欠]',
        '[鄙视]',
        '[委屈]',
        '[奸笑]',
        '[亲亲]',
        '[可怜]',
        '[菜刀]',
        '[西瓜]',
        '[啤酒]',
        '[足球]',
        '[咖啡]',
        '[饭]',
        '[猪头]',
        '[玫瑰]',
        '[凋谢]',
        '[嘴唇]',
        '[爱心]',
        '[心碎]',
        '[蛋糕]',
        '[闪电]',
        '[炸弹]',
        '[便便]',
        '[月亮]',
        '[太阳]',
        '[抱抱]',
        '[强]',
        '[弱]',
        '[握手]',
        '[胜利]',
        '[抱拳]',
        '[勾引]',
        '[拳头]',
        '[差劲]',
        '[爱你]',
        '[沙发]',
        '[药]',
        '[奶瓶]',
        '[OK]',
        '[NO]',
        '[礼物]',
        '[喝彩]',
        '[彩球]',
        '[打伞]',
        '[鞭炮]',
        '[灯笼]',
        '[祈祷]',
        '[双喜]',
        '[帅]',
        '[熊猫]',
        '[青蛙]',
        '[香蕉]',
        '[钻戒]',
        '[灯泡]',
        '[闹钟]',
        '[纸巾]',
        '[钞票]',
        '[K歌]',
        '[手枪]',
        '[飞机]',
        '[开车]',
        '[板砖]',
        '[棒棒糖]',
        '[清茶]',
        '[鼓掌]',
        '[鸡蛋]',
        '[金币]',
    ]
    var arr1 = [],
        arr2 = []
    faceText.replace(/\[(.*?)]|([^\\[]*)/g, function (p0, p1, p2) {
        if (p1) arr1.push(p1)
        if (p2) arr2.push(p2)
    })
    var newCont = faceText
    var faceImg = ''
    var faceEmot = ''
    for (var i = 0; i < arr1.length; i++) {
        var curEmot = '[' + arr1[i] + ']'
        if (arr1[i].indexOf('f_') == -1) {
            //判断是数字还是文字 =>文字
            for (var j = 0; j < emot_text.length; j++) {
                if (curEmot == emot_text[j]) {
                    var k = j + 1
                    if (j < 9) {
                        k = '00' + k
                    } else if (j < 99) {
                        k = '0' + k
                    }
                    if (callback != 'f') {
                        faceImg =
                            '<img src="https://static.kaiba315.com.cn/f_' + k + '.png" style="width: 0.35rem;vertical-align: -10%;">'
                        newCont = newCont.replace('[' + arr1[i] + ']', faceImg)
                    } else {
                        faceEmot = '[f_' + k + ']'
                        newCont = newCont.replace('[' + arr1[i] + ']', faceEmot)
                    }
                }
            }
        } else {
            if (callback != 'f') {
                faceImg = '<img src="https://static.kaiba315.com.cn/' + arr1[i] + '.png" style="width: 0.35rem;vertical-align: -10%;">'
                newCont = newCont.replace('[' + arr1[i] + ']', faceImg)
            }
        }
    }
    return newCont.replace(/\n/g, '<br>')
}

export function roleName(userName, role) {
    if (role > 0) {
        return '<span style="color: #FF9E00;">' + userName + '</span>'
    } else {
        return '<span style="color: #5095F3;">' + userName + '</span>'
    }
}

export function formatAvatar(url) {
    if (url === undefined || url == null || url == '') {
        return process.env.VUE_APP_KB_RESOURCE_HOST + 'sys/head.png'
    }
    return jugeUrl(url) ? url : process.env.VUE_APP_KB_RESOURCE_HOST + url + '?imageMogr2/thumbnail/400x'
}

export function formatQiniuUrlOrNull(url) {
    if (url === undefined || url == null || url == '') {
        return ''
    }
    return jugeUrl(url) ? url : +url
}

export function formatQiniuUrl(url) {
    if (url === undefined || url == null || url == '') {
        return process.env.VUE_APP_KB_RESOURCE_HOST + 'kaiba-logo.png'
    }
    return jugeUrl(url) ? url : process.env.VUE_APP_KB_RESOURCE_HOST + url
}

export function gcj02ToBd09ll(lng, lat) {
    let x_pi = (3.14159265358979324 * 3000.0) / 180.0
    let z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_pi)
    let theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_pi)
    let bdLng = z * Math.cos(theta) + 0.0065
    let bdLat = z * Math.sin(theta) + 0.006
    return { lng: bdLng, lat: bdLat }
}

export function bd0911ToGcj02(lng, lat) {
    let x_pi = (3.14159265358979324 * 3000.0) / 180.0
    let x = lng - 0.0065
    let y = lat - 0.006
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
    let gdLng = z * Math.cos(theta)
    let gdLat = z * Math.sin(theta)
    return { lng: gdLng, lat: gdLat }
}

export function calculateGPSDistance(lng1, lat1, lng2, lat2) {
    let x1 = (lng1 * Math.PI) / 180
    let y1 = (lat1 * Math.PI) / 180
    let x2 = (lng2 * Math.PI) / 180
    let y2 = (lat2 * Math.PI) / 180

    let dx = Math.abs(x1 - x2)
    let dy = Math.abs(y1 - y2)

    let h = Math.sin(dx / 2) * Math.sin(dx / 2) + Math.cos(y1) * Math.cos(y2) * Math.sin(dy / 2) * Math.sin(dy / 2)

    let earth_radius = 6371000
    let distance = 2 * Math.asin(Math.sqrt(h)) * earth_radius
    return distance
}
export function generate32UUID() {
    return UUID().replace(/-/g, '')
}
const jugeUrl = function (URL) {
    var str = URL
    //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
    //下面的代码中应用了转义字符"\"输出一个字符"/"
    var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/
    var objExp = new RegExp(Expression)
    if (objExp.test(str) == true) {
        return true
    } else {
        return false
    }
}

/**
 * 合并执行函数, 默认返回第一个函数的结果
 * @param {(...params: any[]) => any} minHandle
 * @param  {((...params: any[]) => any)[]} functions
 * @returns
 */
export function mergeFunction(minHandle, ...functions) {
    return function (...params) {
        const result = minHandle.apply(this, params)
        functions.forEach((handle) => {
            handle.apply(this, params)
        })

        return result
    }
}

/**
 * 滚动到指定dom
 * @param {object} param
 * @param {string} param.selectors - dom表达式
 *
 */
export function scrollToDom({ selectors }) {
    const dom = document.querySelector(selectors)
    if (!dom) {
        throw new Error('未找到该dom')
    }

    dom.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
}

/**
 * 加载script
 * @param {object} params
 * @param {string} params.src js url
 * @param {string} [params.key]
 * @returns {any}
 */
export const loadScript = (params) => {
    return new Promise((resolve, reject) => {
        const script = window.document.createElement('script')
        script.setAttribute('src', params.src)
        script.async = true
        script.onload = () => {
            resolve(params.key ? window[params.key] : window)
        }
        script.onerror = (error) => {
            reject(error)
        }
        window.document.head.appendChild(script)
    })
}

/**
 * 添加弹幕
 * @param {string} id 容器id
 * @param {string} className 容器样式
 * @param {any} data 弹幕数据
 * @param {any} customBox 自定义容器函数
 * */
export const loadBarrage = (id, className, data, customBox = null) => {
    // 获取弹幕容器
    var container = document.getElementById(id)
    // 定义弹幕速度
    var speed = 2
    // 定义弹幕间隔
    var interval = 3000
    // 定义弹幕索引
    var index = 0
    // 定义弹幕定时器
    var timer = setInterval(function () {
        if (index >= data.length) {
            setTimeout(() => {
                clearInterval(timer)
            }, interval)
            return
        }
        // 获取弹幕数据
        var bullet = data[index]
        // 创建弹幕元素
        var div
        if (customBox) {
            div = customBox()
        } else {
            div = document.createElement('div')
            var img = document.createElement('img')
            var spanName = document.createElement('span')
            var spanContent = document.createElement('span')
            div.appendChild(img)
            div.appendChild(spanName)
            div.appendChild(spanContent)
            div.className = className
            img.src = bullet.url
            spanName.innerText = bullet.name
            spanContent.innerText = bullet.content
        }
        // 随机获取弹幕位置
        var top = index % 2 === 0 ? 10 : 49
        div.style.top = top + 'px'
        // 将弹幕元素添加到容器中
        container.appendChild(div)
        // 计算弹幕宽度
        var width = div.offsetWidth
        // 定义弹幕起始位置
        var left = container.offsetWidth
        div.style.left = left + 'px'
        // 定义弹幕移动定时器
        var bulletTimer = setInterval(function () {
            // 计算弹幕当前位置
            left -= speed
            div.style.left = left + 'px'
            // 判断弹幕是否移出容器
            if (left < -width) {
                // 移除弹幕元素
                container.removeChild(div)
                // 清除弹幕移动定时器
                clearInterval(bulletTimer)
            }
        }, 30)
        // 更新弹幕索引
        index++
    }, interval)
}

/**
 * 资源地址
 */
export const dealwithUrlStaticRemote = (paramUrl, appendUri) => {
    const staticRemote = process.env.VUE_APP_KB_RESOURCE_HOST
    let resultUrl = staticRemote
    if (!paramUrl) return ''
    paramUrl = String(paramUrl)
    let mateValue = undefined
    ;['//', '/', 'http://', 'https://'].some((searchValue) => {
        if (searchValue !== String(paramUrl).substring(0, searchValue.length)) {
            return false
        }
        mateValue = searchValue
        return true
    })
    switch (mateValue) {
        case 'http://':
        case 'https://':
        case '//':
            resultUrl = paramUrl
            break
        case '/':
            resultUrl += `${paramUrl}`
            break
        case undefined:
        default:
            resultUrl += `/${paramUrl}`
    }
    if (resultUrl.startsWith('http://')) {
        const staticHost = App.url.URL(staticRemote)?.hostname
        resultUrl = resultUrl.replace(`http://${staticHost}`, `https://${staticHost}`)
    }
    return appendUri ? `${resultUrl}${App.url.Params(resultUrl).toString() ? '/' : '?'}${appendUri}` : resultUrl
}
